// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3Fdg-","notes":"Notes_notes__3JvAh"};